module.exports = __webpack_public_path__ + "assets/images/testImage.38f2e8ee3eb778a0aea3322bba58baf7.png";